<template>
  <div class="modal-category-kbli" v-if="kbliData">
    <!-- <div class="horizontal">
      <div class="column5"></div>
      <div class="column10">Kode</div>
      <div class="column30 mr10">Keterangan</div>
    </div> -->
    <div>
      <InputIcons
        :inputClass="'border-input-red'"
        :placeholder="'Cari sub kegiatan usaha utama ...'"
        v-model="subSearch"
        :model="subSearch"
      />
    </div>
    <div class="w-full text-red non-mobile-class">
      {{ parentName }}
    </div>
    <div class="horizontal" v-for="(item, index) in kbli" :key="index">
      <div class="column5">
        <input
          class="modal-input-checkbox-level-two"
          type="checkbox"
          :id="index"
          :value="item"
          v-model="choose"
        />
      </div>
      <div class="column15">{{ item.kode }}</div>
      <div class="column80 col-nohover mr10">{{ item.desc }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['parentId', 'parentName'],
  components: {
    Loading: () => import('@/components/utils/Loading'),
    InputIcons: () => import('@/components/Atoms/InputIcons'),
  },
  data() {
    return {
      kbli: [],
      subKbliMaster: [],
      choosedKbli: [],
      subSearch: '',
      delKbli: [],
      addKbli: [],
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedKbli',
          value: newValue,
        })
      },
    },
    kbliData: function() {
      return this.setUpData()
    },
  },
  watch: {
    subSearch: function(newValue, oldValue) {
      this.searchRun()
    },
    parentId: async function(newValue, oldValue) {
      console.log('watch: ', newValue, oldValue)
      await this.resetPlaceholder()
      await this.onFilter()
    },
  },
  methods: {
    async onFilter() {
      const search = String(this.subSearch)
      const list = this.subKbliMaster

      let filteredList = []
      for (let i in list) {
        if (list[i].parent_id.toLowerCase().indexOf(this.parentId) != -1) {
          filteredList.push(list[i])
        }
      }

      this.kbli = filteredList
    },
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subKbliMaster

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.kbli = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      // this.subKbli = this.subKbliMaster
    },
    async setUpData() {
      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: true,
      })
      const getKbli = await this.$getKbli()
      const defaultKbli = await this.$store.state.level1.choosedKbli

      let reduceKbli = await getKbli.reduce(
        (a, b) => ({ ...a, [b.kode]: b }),
        {}
      )

      let reduceDefault =
        (await defaultKbli) &&
        defaultKbli.reduce((a, b) => ({ ...a, [b.kode]: b }), {})

      let combine = { ...reduceKbli, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.kbli = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subKbliMaster = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedKbli = await defaultKbli.map(list => {
        return list.id
      })

      console.log('kbli list: ', this.subKbliMaster)

      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: false,
      })
    },
  },
}
</script>
